export default __webpack_public_path__ + "static/media/BeFly.e4cefae5.png";